import { render } from "./content-footer.vue?vue&type=template&id=46072461&scoped=true"
import script from "./content-footer.vue?vue&type=script&lang=js"
export * from "./content-footer.vue?vue&type=script&lang=js"

import "./content-footer.vue?vue&type=style&index=0&id=46072461&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46072461"]])

export default __exports__